import { render, staticRenderFns } from "./CorpusTable.vue?vue&type=template&id=3b9cd087"
import script from "./CorpusTable.vue?vue&type=script&lang=ts"
export * from "./CorpusTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports